import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-categories/new/loading';

export const Route = createFileRoute('/_private/settings/inventory-categories/new')({
  component: Loading,
});
